import { timeQuery } from 'helpers/Utils';
export class SettingsInvoice {
    constructor(props) {
        Object.assign(this, props);
        this.updated = new Date(props.updated);
        this.image = timeQuery(props.image, this.updated);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/SettingsInvoice/Model.ts
// module id = 341
// module chunks = 0